(function() {
	'use strict';

	function init() {

		const toggles = document.querySelectorAll(
			'.rpmblock--partner-logo-grid__accordion-toggle'
		);

		toggles.forEach(function(toggle) {

			toggle.addEventListener('click', function() {

				const contentId = this.getAttribute('aria-controls');
				const content = document.getElementById(contentId);

				if (!content) {
					return;
				}

				const isOpen = this.getAttribute('aria-expanded') === 'true';

				if (isOpen) {
					this.setAttribute('aria-expanded', 'false');
					content.setAttribute('hidden', '');
				} else {
					this.setAttribute('aria-expanded', 'true');
					content.removeAttribute('hidden');
				}

			});

		});

	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', init);
	} else {
		init();
	}

})();